import React, { useState, useEffect } from "react";

import { useSelector } from "react-redux";
import './styles.scss'
import {
    AppLayout,
    Box,
} from "@amzn/awsui-components-react";
import SideNav from "./SideNav";
import { useLocation } from "react-router-dom";
import useVisibleTimeTracker from 'src/katalMetrics/useVisibleTimeTracker';
import { ACTION_METHODS, METRIC_TYPE, SITE_SERVICES } from 'src/katalMetrics/metricsModels';

import FirstPassHistoryComponent from "./Components/FirstPassHistoryComponent";
export default (props) => {
    const [NavOpen, setNavOpen] = useState(false);
    const [customSideNavitems, setCustomSideNavitems] = useState([
        {
            "type": "link",
            "text": "About",
            "href": `/firstpass`
        },

        { "type": "divider" },

        {
            "type": "link",
            "text": "Back",
            "href": "/"
        },
    ])
    const userId = useSelector((globalState) => globalState.auth.userId);
    const currentStage = useSelector((globalState) => globalState.auth.currentStage)
    const ln = useLocation()

    useVisibleTimeTracker([{
        metricName: 'actionPerformedBy',
        metricValue: userId,
        metricType: METRIC_TYPE.STRING,
        isMonitor: true
    },
    {
        metricName: 'pagePath',
        metricValue: `${ln.pathname}`,
        metricType: METRIC_TYPE.STRING,
        isMonitor: true
    }
    ], "timeSpent", ACTION_METHODS.TIME_SPENT_ON_PAGE, SITE_SERVICES.FIRST_PASS_PRO);

    useEffect(() => {
    }, [userId, currentStage])

    const Content = (
        <Box margin="l">
            <FirstPassHistoryComponent></FirstPassHistoryComponent>
        </Box>
    )

    return (
        <AppLayout
            disableContentPaddings={true}
            navigation={<SideNav activeHref={`/firstpass`} customSideNavitems={customSideNavitems} />}
            navigationOpen={NavOpen}
            content={Content}
            headerSelector="#TopBar"
            toolsHide={true}
            navigationHide={true}
            onNavigationChange={() => {
                setNavOpen(!NavOpen);
            }}
            headerVariant="high-contrast"
        />

    );
}
